// extracted by mini-css-extract-plugin
export default {"wrapper":"Notice_wrapper__q4AG2","narrow":"Notice_narrow__nWsZI"};